import {Injectable} from '@angular/core';
import {MatDatepickerIntl} from '@angular/material/datepicker';

@Injectable()
export class DatepickerIntlPl extends MatDatepickerIntl {

  closeCalendarLabel = 'Zamknij kalendarz';
  calendarLabel = 'Okno kalendarza';
  openCalendarLabel = 'Otwórz kalendarz';
  prevMonthLabel = 'Poprzedni miesiąc';
  nextMonthLabel = 'Następny miesiąc';
  prevYearLabel = 'Poprzedni rok';
  nextYearLabel = 'Następny rok';
  prevMultiYearLabel = 'Poprzednie lata';
  nextMultiYearLabel = 'Następne lata';
  switchToMonthViewLabel = 'Przełącz do widoku miesięcznego';
  switchToMultiYearViewLabel = 'Przełącz do widoku wieloletniego';

}
